module.exports = __webpack_public_path__ + "static/achievement-1-796a1899dcf40839d9840108c94ad765.svg";